import { DPickerProps } from './types';
import { TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react';
import { FieldValues, useController } from 'react-hook-form';

const DatePickerInput = <Form extends FieldValues>(props: DPickerProps<Form>): JSX.Element => {
  const {
    field: { value, onChange, onBlur },
    fieldState: { error },
  } = useController(props);

  const { label, testId, styles, disabled, maxDate, minDate, popperProps, readOnly } = props;

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <LocalizationProvider dateAdapter={AdapterDateFns as any}>
      <DatePicker
        readOnly={readOnly}
        onChange={onChange}
        value={value}
        label={label}
        className={styles}
        disabled={disabled}
        data-testid={testId}
        maxDate={maxDate}
        minDate={minDate}
        onClose={onBlur}
        PopperProps={popperProps}
        renderInput={(params) => (
          <TextField
            {...params}
            color="info"
            data-testid={testId}
            onBlur={onBlur}
            error={Boolean(error)}
            helperText={error?.message || ' '}
            disabled={disabled}
          />
        )}
        inputFormat={'dd/MM/yyyy'}
      />
    </LocalizationProvider>
  );
};

export default DatePickerInput;
